import React from "react";
import { Button, Dropdown } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

function OptimisationReviewFooter({
  handleCancel,
  calculateSavings,
  hasSelectedRows,
  hasCalculated,
  needsRecalc,
  spinning,
  downloadReport,
}) {
  return (
    <div className="optimisation-review__footer">
      <div className="optimisation-review__footer-left">
        <Button
          className="optimisation-review__btn-secondary"
          onClick={handleCancel}
        >
          Clear All
        </Button>
      </div>
      <div className="optimisation-review__footer-right">
        <Button
          className="optimisation-review__btn-secondary"
          onClick={calculateSavings}
          disabled={!hasSelectedRows || spinning}
        >
          {needsRecalc ? "Recalculate Savings" : "Calculate Savings"}
        </Button>
        <Dropdown
          disabled={!hasCalculated}
          menu={{
            items: [
              {
                key: "xlsx",
                label: "Download as Excel (.xlsx)",
                onClick: () => downloadReport("xlsx"),
              },
              {
                key: "csv",
                label: "Download as CSV (.csv)",
                onClick: () => downloadReport("csv"),
              },
            ],
          }}
        >
          <Button
            type="primary"
            className="optimisation-review__btn-primary"
            icon={<DownloadOutlined />}
            disabled={!hasCalculated}
          >
            Download Report
          </Button>
        </Dropdown>
      </div>
    </div>
  );
}

export default React.memo(OptimisationReviewFooter);
